
enum NoItemSelectedViewControllerType {    
    None,
    InventoryNote,
    MovementNote,
    OutputNote,
    SupplierOrder,
    SupplierNote,
    StockOrder,  
    DeliveryNote,
    DeliveryRoutes,
    Supplier, 
    CashDesk,        
    EventProgram,
    Shows,
    Report,
    BookingIntermediary,
    Setup,
    Product,
    ProductModifiers,
    ProductRates,
    Menus,
    Client,
    Ticket,
    Invoice,
    Worker,
    ProductCategory,
    Offer,
    LowStockProducts,
    BankAccount,
    BankBundleFiles,
    License,
    GuestList,
    Events,
    ReportBuilder,
    InternalReturnOrder,
    SupportTickets,
    ProductPresets,
    Partner,
    BuyOrder,
    StockTemplate,
    OnlineOrder,
    AppConfiguration,
    Distributor,
    InputNote,
    AppConsumptionProfile,
    BookingSource,
    Application,
    Loan,
    DeliveryOrder,
    TransferNote,
    QuotationDocument,
    PurchaseInvoiceProcessingOCR,
    ProductionNote
}
class NoItemSelectedViewController extends MUIViewController
{
    static newInstance() : NoItemSelectedViewController {
        let vc = new NoItemSelectedViewController("no-item-selected-view");
        vc.initWithResource("layout/base/NoItemSelectedView.html");
        return vc;
    }

    defaultView:MUIView = null;
    clientView:MUIView = null;
    inventoryNoteView:MUIView = null;
    movementNoteView:MUIView = null;
    outputNoteView:MUIView = null;
    supplierOrderView:MUIView = null;
    supplierNoteView:MUIView = null;
    purchaseInvoiceProcessingView:MUIView = null;

    viewDidLoad(){
        super.viewDidLoad();

        this.defaultView = MUIOutlet(this, "base-no-select");
        this.clientView = MUIOutlet(this, "client-no-select");
        this.inventoryNoteView = MUIOutlet(this, "inventory-note-no-select");
        this.movementNoteView = MUIOutlet(this, "movement-note-no-select");
        this.outputNoteView = MUIOutlet(this, "output-note-no-select");
        this.supplierOrderView = MUIOutlet (this, "supplier-order-no-select");
        this.supplierNoteView = MUIOutlet(this, "supplier-note-no-select");
        this.purchaseInvoiceProcessingView = MUIOutlet(this, "purchase-invoice-processing-no-select");
    }

    viewWillAppear(animated?){
        super.viewWillAppear(animated);
        this.updateUI();
    }

    private _type:NoItemSelectedViewControllerType = null;
    set type(type:NoItemSelectedViewControllerType){
        this._type = type;        
    }

    private updateUI(){
        if (this.viewIsLoaded == false) return;

        switch(this._type) {            
            case NoItemSelectedViewControllerType.Client:
            MUICoreLayerRemoveStyle(this.clientView.layer, "hidden");
            break;

            case NoItemSelectedViewControllerType.InventoryNote:
            MUICoreLayerRemoveStyle(this.inventoryNoteView.layer, "hidden");
            break;

            case NoItemSelectedViewControllerType.MovementNote:
            MUICoreLayerRemoveStyle(this.movementNoteView.layer, "hidden");
            break;

            case NoItemSelectedViewControllerType.OutputNote:
            MUICoreLayerRemoveStyle(this.outputNoteView.layer, "hidden");
            break;
            
            case NoItemSelectedViewControllerType.SupplierOrder:
            MUICoreLayerRemoveStyle(this.supplierOrderView.layer, "hidden");
            break;

            case NoItemSelectedViewControllerType.SupplierNote:
            MUICoreLayerRemoveStyle(this.supplierNoteView.layer, "hidden");
            break;

            case NoItemSelectedViewControllerType.PurchaseInvoiceProcessingOCR:
            MUICoreLayerRemoveStyle(this.purchaseInvoiceProcessingView.layer, "hidden");
            break;

            default:
            MUICoreLayerRemoveStyle(this.defaultView.layer, "hidden");
            break;
        }
    }
}